import React from 'react'
import {Icon} from '@chakra-ui/react'

const ShareIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="share" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.4586 26.0833C29.8412 26.0833 28.4534 27.0819 27.8851 28.5016L27.885 28.5018C27.7089 28.9415 27.6113 29.4227 27.6113 29.9306C27.6113 32.0553 29.3338 33.7778 31.4586 33.7778C33.5833 33.7778 35.3058 32.0553 35.3058 29.9306C35.3058 27.8058 33.5833 26.0833 31.4586 26.0833ZM25.1 27.3865C26.1087 24.8671 28.5736 23.0833 31.4586 23.0833C35.2402 23.0833 38.3058 26.1489 38.3058 29.9306C38.3058 33.7122 35.2402 36.7778 31.4586 36.7778C27.6769 36.7778 24.6113 33.7122 24.6113 29.9306C24.6113 29.0345 24.7842 28.1752 25.1 27.3867"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.9356 29.337L12.9512 24.1432L14.0654 21.3577L27.0498 26.5516L25.9356 29.337Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.2459 13.6905L14.0226 19.8614L12.7539 17.1429L25.9772 10.972L27.2459 13.6905Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.4586 6.22221C29.3338 6.22221 27.6113 7.94467 27.6113 10.0694C27.6113 10.6538 27.7406 11.2038 27.9707 11.696L27.9707 11.696C28.5853 13.0108 29.9177 13.9167 31.4586 13.9167C33.5833 13.9167 35.3058 12.1942 35.3058 10.0694C35.3058 7.94467 33.5833 6.22221 31.4586 6.22221ZM24.6113 10.0694C24.6113 6.28781 27.6769 3.22221 31.4586 3.22221C35.2402 3.22221 38.3058 6.28781 38.3058 10.0694C38.3058 13.8511 35.2402 16.9167 31.4586 16.9167C28.7098 16.9167 26.3424 15.2969 25.253 12.9665C24.8408 12.0848 24.6113 11.1018 24.6113 10.0694Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.54156 16.9167C6.41679 16.9167 4.69434 18.6391 4.69434 20.7639C4.69434 22.8886 6.41679 24.6111 8.54156 24.6111C10.1589 24.6111 11.5467 23.6126 12.1151 22.1928C12.2912 21.7529 12.3888 21.2717 12.3888 20.7639C12.3888 20.1796 12.2595 19.6296 12.0294 19.1372M1.69434 20.7639C1.69434 16.9823 4.75994 13.9167 8.54156 13.9167C11.2903 13.9167 13.6577 15.5363 14.7471 17.8668L14.7472 17.8669C15.1593 18.7486 15.3888 19.7315 15.3888 20.7639C15.3888 21.6601 15.2159 22.5193 14.9002 23.3078L14.9002 23.3078C13.8915 25.8272 11.4267 27.6111 8.54156 27.6111C4.75994 27.6111 1.69434 24.5455 1.69434 20.7639ZM8.54156 16.9167C10.0824 16.9167 11.4148 17.8225 12.0294 19.1372L8.54156 16.9167Z"
                fill="currentColor"
            />
        </Icon>
    )
}
export default ShareIcon
